'use client';

import { Link, Text } from 'pcln-design-system';
import React, { memo } from 'react';
/** @public */
function ContentfulCallToAction({
  ariaLabel,
  color,
  fontSize,
  fontWeight,
  label,
  longUrl,
  openInNewTab,
  textStyle,
  url,
  ...props
}) {
  const href = longUrl || url;
  const target = openInNewTab ? '_blank' : '_self';
  return (
    // @ts-ignore
    React.createElement(Link, {
      "aria-label": ariaLabel,
      color: color,
      href: href,
      target: target,
      ...props
    }, React.createElement(Text, {
      fontSize: fontSize,
      fontWeight: fontWeight,
      textStyle: textStyle
    }, label))
  );
}
export default memo(ContentfulCallToAction);